module.exports = __webpack_public_path__ + "static/media/dashboardIcon.1a325e46.svg";